import {useMemo} from "react";
import {useSelector} from "react-redux";

import {upperFirst} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {buildPromotionListUrlFromRegion} from "../helpers/build_promotion_list_url";
import {getPromotionListingConfig, isPromotionListingType} from "../helpers/promotion_listing_config";

export const usePromotionTypeListByCurrentRegion = (currentPromotionType: number) => {
    const promotionsStatistic = useSelector((state: IRPStore) => state.promotionList.statistic);
    const region = useSelector((state: IRPStore) => state.promotionList.region);

    const availablePromotions = useMemo(() => {
        if (!region?.slug) {
            return [];
        }

        return (
            promotionsStatistic
                ?.map((promotionStatistic) => ({
                    type: promotionStatistic.type,
                    label: isPromotionListingType(promotionStatistic.type) ? getPromotionListingConfig(promotionStatistic.type).fullLabel : "",
                    count: promotionStatistic.count
                }))
                .filter(
                    (promotion) => !!promotion.label && promotion.count > 0 && promotion.type !== currentPromotionType && isPromotionListingType(promotion.type)
                ) || []
        );
    }, [region?.slug, promotionsStatistic]);

    const promotionLinks = useMemo(() => {
        if (!region?.slug) {
            return [];
        }

        return (
            availablePromotions?.map((promotion) => ({
                href: buildPromotionListUrlFromRegion({region, type: promotion.type}),
                text: upperFirst(`${promotion.label} ${region?.name_declension_where}`)
            })) || []
        );
    }, [region?.slug, promotionsStatistic]);

    return {
        availablePromotions,
        promotionLinks
    };
};
import {useMemo} from "react";
import {useSelector} from "react-redux";

import {upperFirst} from "@pg-mono/nodash";

import {IRPStore} from "../../app/rp_reducer";
import {buildPromotionListUrlFromRegion} from "../helpers/build_promotion_list_url";
import {getPromotionListingConfig, isPromotionListingType} from "../helpers/promotion_listing_config";

export const usePromotionTypeListByCurrentRegion = (currentPromotionType: number) => {
    const promotionsStatistic = useSelector((state: IRPStore) => state.promotionList.statistic);
    const region = useSelector((state: IRPStore) => state.promotionList.region);

    const availablePromotions = useMemo(() => {
        if (!region?.slug) {
            return [];
        }

        return (
            promotionsStatistic
                ?.map((promotionStatistic) => ({
                    type: promotionStatistic.type,
                    label: isPromotionListingType(promotionStatistic.type) ? getPromotionListingConfig(promotionStatistic.type).fullLabel : "",
                    count: promotionStatistic.count
                }))
                .filter(
                    (promotion) => !!promotion.label && promotion.count > 0 && promotion.type !== currentPromotionType && isPromotionListingType(promotion.type)
                ) || []
        );
    }, [region?.slug, promotionsStatistic]);

    const promotionLinks = useMemo(() => {
        if (!region?.slug) {
            return [];
        }

        return (
            availablePromotions?.map((promotion) => ({
                href: buildPromotionListUrlFromRegion({region, type: promotion.type}),
                text: upperFirst(`${promotion.label} ${region?.name_declension_where}`)
            })) || []
        );
    }, [region?.slug, promotionsStatistic]);

    return {
        availablePromotions,
        promotionLinks
    };
};
